import { queryClient } from 'api/services/queryClient';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { CreateCreditInvoiceArg, CreateCreditInvoiceResponse } from 'lib/services';
import { type UseMutationResult, useMutation } from 'react-query';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useCreateCreditInvoice = (): UseMutationResult<
  CreateCreditInvoiceResponse,
  unknown,
  CreateCreditInvoiceArg
> => {
  const notify = useAppNotifications();
  const { creditInvoicesApiClient } = useServices();

  return useMutation((arg: CreateCreditInvoiceArg) => creditInvoicesApiClient.create(arg), {
    mutationKey: MUTATION_KEYS.creditInvoices.create(),
    onError: error => {
      notify.error({
        message: 'There was an error while creating credit invoice',
        description: error instanceof Error ? error.message : undefined,
      });
    },
    onSuccess: () => {
      notify.success({
        message: `Credit invoice created`,
      });
      queryClient.invalidateQueries(QUERY_KEYS.creditInvoices.all());
    },
  });
};
